import * as React from 'react';

import type {
    ContactSearchResultByType as ContactSearchResultFragment,
    AccountSearchResultByType as AccountSearchResultFragment,
    LeadSearchResultByType as LeadSearchResultFragment,
} from 'nutshell-graphql-types';

import {SearchResultLead} from './search-result-lead';
import {SearchResultPeep} from './search-result-peep';

type Props = {
    searchResult:
        | ContactSearchResultFragment
        | AccountSearchResultFragment
        | LeadSearchResultFragment;
    isActive?: boolean;
};

export const SearchResult = (props: Props) => {
    switch (props.searchResult.__typename) {
        case 'Lead':
            return React.createElement(SearchResultLead, {
                ...props.searchResult,
                isActive: Boolean(props.isActive),
            });
        case 'Account':
        case 'Contact':
            return React.createElement(SearchResultPeep, {
                peep: props.searchResult,
                isActive: Boolean(props.isActive),
            });
        default:
            return null;
    }
};
